export default function formattedDate (lang, dateStr, format = 'month-day', formatOptions = {}, contextYearMonth = null) {
    // 날짜 문자열이 "yyyy-MM" 형식인지 확인
    const isYearMonth = /^\d{4}-\d{2}$/.test(dateStr)
    const isYearMonthDay = /^\d{4}-\d{2}-\d{2}$/.test(dateStr)
    const isDayOnly = /^\d{1,2}$/.test(dateStr) // 1~31 또는 01~31 허용

    if (!isYearMonth && !isYearMonthDay && !isDayOnly) {
        console.error(dateStr)
        throw new Error("Invalid date format. Expected 'yyyy-MM', 'yyyy-MM-dd' or 'dd'")
    }

    let date
    if (isYearMonth) {
        // "yyyy-MM"이면 뒤에 "-01"을 붙여서 "yyyy-MM-dd"로 변환
        date = new Date(`${dateStr}-01`)
    } else if (isYearMonthDay) {
        // "yyyy-MM-dd"이면 그대로 처리
        date = new Date(dateStr)
    } else if (isDayOnly) {
        // "dd" 형식이면 contextYearMonth가 있으면 해당 연도/월을 사용, 없으면 현재 연도/월을 사용
        const yearMonth = contextYearMonth || new Date().toISOString().slice(0, 7)
        date = new Date(`${yearMonth}-${dateStr}`)
    }

    if (format === 'yyyy-MM') {
        return dateStr // 원본 유지
    }
    if (format === 'yyyy-MM-dd') {
        return dateStr // 원본 유지
    }

    // Intl.DateTimeFormat을 사용하는 경우
    const options = {}
    if (format === 'year-month') {
        options.year = formatOptions.year || 'numeric'
        options.month = formatOptions.month || 'short'
    } else if (format === 'year-month-day') {
        options.year = formatOptions.year || 'numeric'
        options.month = formatOptions.month || 'short'
        options.day = formatOptions.day || 'numeric'
    } else if (format === 'day') {
        options.day = formatOptions.day || 'numeric'
    } else {
        options.month = formatOptions.month || 'short'
        options.day = formatOptions.day || 'numeric'
    }

    return new Intl.DateTimeFormat(lang, options).format(date)
}
